<script setup>

const props = defineProps({
  locale: {
    type: String,
    default: "fa",
  },
})


const data = {
  fa: {
    why: "چرا فراپلیمر شریف",
    items: [
      { icon: "", title: "انعطاف‌پذیری در فروش", detail: "ارائه مدل‌های متفاوت فروش (پروفرم، قرارداد ریالی، بار موجود)، شرایط متنوع پرداخت اعتباری بانکی متناسب با شرایط خرید هر مشتری" },
      { icon: "", title: "تأمین‌کننده پایدار صنعت پلیمر ", detail: "اخذ نمایندگی از برندهای معتبر جهان، خرید مستقیم و بی‌واسطه از تولیدکنندگان بزرگ پلاستیک‌های مهندسی، ارائه مستمر سبدی کامل از پلاستیک‌های مهندسی پرمصرف" },
      { icaon: "", title:"نیروی‌های بازرگانی متخصص", detail: "مدیران و کارشناسان باتجربه با دانش بازرگانی و تخصصی پلیمری، پشتیبانی واحد تحقیق و توسعه و امکان انجام آزمایش‌های پلیمری" },
    ] 
  },

  en: {
    why: "Why Fara Polymer Sharif",
    items: [
      { icon: "", title: "Sales Flexibility", detail: "We offer various sales models (proforma, rial contracts, available stock) along with diverse banking credit payment terms tailored to each customer's purchasing conditions." },
      { icon: "", title: "Sustainable Supplier for the Polymer Industry", detail: "We have secured representation from world-renowned brands and buy directly from leading manufacturers of engineering plastics, without intermediaries, consistently providing a comprehensive range of high-demand engineering plastics." },
      { icon: "", title: "Specialized Commercial Team", detail: "Experienced managers and experts with a strong understanding of both business and polymer technology, along with the support of our R&D department and the capability to perform polymer testing, are the reasons to choose Fara Polymer Sharif." },
    ]
  },

}

</script>

<template>
  <!-- Features -->
  <div class="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
    <div class="relative p-6 md:p-16">
      <!-- Grid -->
      <div class="relative z-10 lg:grid lg:grid-cols-12 lg:gap-16 lg:items-center">
        <div class="mb-10 lg:mb-0 lg:col-span-6 lg:col-start-8 lg:order-2">
          <h2 class="text-2xl text-gray-800 font-bold sm:text-3xl dark:text-gray-200">
            {{ data[props.locale].why }}
          </h2>

          <!-- Tab Navs -->
          <nav class="grid gap-4 mt-5 md:mt-10" aria-label="Tabs" role="tablist">
            <button v-for="item in data[props.locale].items" type="button"
              class="hs-tab-active:bg-white hs-tab-active:shadow-md hs-tab-active:hover:border-transparent text-start hover:bg-gray-200 p-4 md:p-5 rounded-xl dark:hs-tab-active:bg-slate-900 dark:hover:bg-gray-700 active"
              id="tabs-with-card-item-1" data-hs-tab="#tabs-with-card-1" aria-controls="tabs-with-card-1" role="tab">
              <span class="flex">
                <svg
                  class="flex-shrink-0 mt-2 size-6 md:size-7 hs-tab-active:text-blue-600 text-gray-800 dark:hs-tab-active:text-blue-500 dark:text-gray-200"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z" />
                  <path d="M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z" />
                  <path d="M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z" />
                  <path d="M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z" />
                  <path d="M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z" />
                </svg>
                <span class="grow ms-6">
                  <span
                    class="block text-lg font-semibold hs-tab-active:text-blue-600 text-gray-800 dark:hs-tab-active:text-blue-500 dark:text-gray-200">    
                    {{ item.title }}
                  </span>
                  <span class="block mt-1 text-gray-800 dark:hs-tab-active:text-gray-200 dark:text-gray-200 text-justify">
                    {{ item.detail }}
                    </span>
                </span>
              </span>
            </button>


            <button v-if="0" type="button"
              class="hs-tab-active:bg-white hs-tab-active:shadow-md hs-tab-active:hover:border-transparent text-start hover:bg-gray-200 p-4 md:p-5 rounded-xl dark:hs-tab-active:bg-slate-900 dark:hover:bg-gray-700"
              id="tabs-with-card-item-3" data-hs-tab="#tabs-with-card-3" aria-controls="tabs-with-card-3" role="tab">
              <span class="flex">
                <svg
                  class="flex-shrink-0 mt-2 size-6 md:size-7 hs-tab-active:text-blue-600 text-gray-800 dark:hs-tab-active:text-blue-500 dark:text-gray-200"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path
                    d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
                  <path d="M5 3v4" />
                  <path d="M19 17v4" />
                  <path d="M3 5h4" />
                  <path d="M17 19h4" />
                </svg>
                <span class="grow ms-6">
                  <span
                    class="block text-lg font-semibold hs-tab-active:text-blue-600 text-gray-800 dark:hs-tab-active:text-blue-500 dark:text-gray-200">نیروی
                   ‌های بازرگانی متخصص</span>
                  <span class="block mt-1 text-gray-800 dark:hs-tab-active:text-gray-200 dark:text-gray-200">هر مدیر
                    منطقه فرا پلیمر حداقل یک دهه تجربه در صنعت پلیمر دارد</span>
                </span>
              </span>
            </button>
          </nav>
          <!-- End Tab Navs -->
        </div>
        <!-- End Col -->

        <div class="lg:col-span-6">
          <div class="relative">
            <!-- Tab Content -->
            <div>
              <div id="tabs-with-card-1" role="tabpanel" aria-labelledby="tabs-with-card-item-1">
                <img class="shadow-xl shadow-gray-200 rounded-xl dark:shadow-gray-900/[.2]" src="/img/exchange.jpg"
                  alt="" srcset="">
              </div>

              <div id="tabs-with-card-2" class="hidden" role="tabpanel" aria-labelledby="tabs-with-card-item-2">
                <img class="shadow-xl shadow-gray-200 rounded-xl dark:shadow-gray-900/[.2]" src="/img/port.jpg" alt=""
                  srcset="">
              </div>

              <div id="tabs-with-card-3" class="hidden" role="tabpanel" aria-labelledby="tabs-with-card-item-3">
                <img class="shadow-xl shadow-gray-200 rounded-xl dark:shadow-gray-900/[.2]" src="/img/experts.jpg"
                  alt="" srcset="">
              </div>
            </div>
            <!-- End Tab Content -->

            <!-- SVG Element -->
            <div class="hidden absolute top-0 end-0 translate-x-20 md:block lg:translate-x-20">
              <svg class="w-16 h-auto text-orange-500" width="121" height="135" viewBox="0 0 121 135" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M5 16.4754C11.7688 27.4499 21.2452 57.3224 5 89.0164" stroke="currentColor" stroke-width="10"
                  stroke-linecap="round" />
                <path d="M33.6761 112.104C44.6984 98.1239 74.2618 57.6776 83.4821 5" stroke="currentColor"
                  stroke-width="10" stroke-linecap="round" />
                <path d="M50.5525 130C68.2064 127.495 110.731 117.541 116 78.0874" stroke="currentColor"
                  stroke-width="10" stroke-linecap="round" />
              </svg>
            </div>
            <!-- End SVG Element -->
          </div>
        </div>
        <!-- End Col -->
      </div>
      <!-- End Grid -->

      <!-- Background Color -->
      <div class="absolute inset-0 grid grid-cols-12 size-full">
        <div
          class="col-span-full lg:col-span-7 lg:col-start-6 bg-gray-100 w-full h-5/6 rounded-xl sm:h-3/4 lg:h-full dark:bg-white/[.075]">
        </div>
      </div>
      <!-- End Background Color -->
    </div>
  </div>
  <!-- End Features -->
</template>